import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteActivity } from '../../../../actions/mechanical-maintenance/Activity';

const ActivityDeleteButton = ({
  dispatchDeleteActivity,
  activityId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteActivity({ activityId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

ActivityDeleteButton.propTypes = {
  dispatchDeleteActivity: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  activityId: PropTypes.number.isRequired,
};

ActivityDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteActivity: deleteActivity,
};

export default connect(null, mapDispatchToProps)(ActivityDeleteButton);
